import { Icons } from '@icons/icons';

import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EAssetSiteA11yStatus = {
	amber: 'AMBER',
	green: 'GREEN',
	red: 'RED',
	none: 'NONE',
} as const;

export const EBackhaulA11yStatus = {
	amber: 'AMBER',
	green: 'GREEN',
	red: 'RED',
	none: 'NONE',
} as const;

export const EPowerSupplyA11yStatus = {
	amber: 'AMBER',
	green: 'GREEN',
	red: 'RED',
	none: 'NONE',
} as const;

//TODO: remove after all updates
export const EAssetType = {
	anprColumn: 'ANPR_COLUMN',
	bench: 'BENCH',
	bin: 'BIN',
	building: 'BUILDING',
	busStop: 'BUS_STOP',
	cctv: 'CCTV',
	digitalSignage: 'DIGITAL_SIGNAGE',
	lampColumn: 'LAMP_COLUMN',
	land: 'LAND',
	streetSign: 'STREET_SIGN',
	trafficSign: 'TRAFFIC_SIGN',
	trafficSignal: 'TRAFFIC_SIGNAL',
	accessPoints: 'ACCESS_POINTS',
	tflStations: 'TFL_STATIONS',
	pops: 'POPS',
} as const;

//TODO: remove after all updates
export const EAssetSubType = {
	buildingNonResidential: 'BUILDING_NON_RESIDENTIAL',
	buildingResidential: 'BUILDING_RESIDENTIAL',
	depotLight: 'DEPOT_LIGHT',
	gasDestructorNbsp: 'GAS_DESTRUCTOR_NBSP',
	highMast: 'HIGH_MAST',
	hingedColumn: 'HINGED_COLUMN',
	light: 'LIGHT',
	soffitMount: 'SOFFIT_MOUNT',
	switchLamp: 'SWITCH_LAMP',
	switchMount: 'SWITCH_MOUNT',
	upLighter: 'UPLIGHTER',
	wallLamp: 'WALL_LAMP',
	wallBracket: 'WALL_BRACKET',
	rlColumn: 'RL_COLUMN',
	poleBracket: 'POLE_BRACKET',
	column: 'COLUMN',
	withoutSubtype: 'NO_SUBTYPE',
} as const;

export const EResponsibleType = {
	la: 'LA',
	pfi: 'PFI',
} as const;

//TODO: remove after all updates

export const EAssetTypeIcons = {
	[EAssetType.anprColumn]: Icons.anprColumn(),
	[EAssetType.bench]: Icons.bench(),
	[EAssetType.bin]: Icons.bin(),
	[EAssetType.building]: Icons.building(),
	[EAssetType.busStop]: Icons.busStop(),
	[EAssetType.cctv]: Icons.cctv(),
	[EAssetType.digitalSignage]: Icons.digitalSignage(),
	[EAssetType.lampColumn]: Icons.lamppost(),
	[EAssetType.land]: Icons.land(),
	[EAssetType.streetSign]: Icons.streetSign(),
	[EAssetType.trafficSign]: Icons.trafficSign(),
	[EAssetType.trafficSignal]: Icons.trafficLight(),
	[EAssetType.accessPoints]: Icons.accessPoint(),
	[EAssetType.tflStations]: Icons.tflStations(),
	[EAssetType.pops]: Icons.pops(),
};

export const EColorAssetsBy = {
	siteAvailability: 'assetSiteAvailabilityStatus',
	powerSupplyAvailability: 'powerSupplyAvailabilityStatus',
	backhaulAccessibility: 'backhaulAccessibilityStatus',
	none: 'none',
} as const;

export const EMarkerTypes = {
	cluster: 'CLUSTER',
	point: 'POINT',
} as const;

export const EMapMode = {
	view: 'view',
	draw: 'draw',
	addMarker: 'addMarker',
} as const;

export const EPolygonType = {
	polygon: 'polygon',
	circle: 'circle',
} as const;

export const EMapOverlayCardPositions = {
	right: 'right',
	left: 'left',
	dynamic: 'dynamic',
} as const;

export const EDataType = {
	assets: 'assets',
	sites: 'sites',
} as const;

export type TAssetSiteA11yStatus = TValueOfStringRecord<typeof EAssetSiteA11yStatus>
export type TBackhaulA11yStatus = TValueOfStringRecord<typeof EBackhaulA11yStatus>
export type TPowerSupplyA11yStatus = TValueOfStringRecord<typeof EPowerSupplyA11yStatus>
export type TAssetType = TValueOfStringRecord<typeof EAssetType>
export type TAssetSubType = TValueOfStringRecord<typeof EAssetSubType>
export type TResponsibleType = TValueOfStringRecord<typeof EResponsibleType>
export type TColorAssetsBy = TValueOfStringRecord<typeof EColorAssetsBy>
export type TMarkerTypes = TValueOfStringRecord<typeof EMarkerTypes>
export type TMapMode = TValueOfStringRecord<typeof EMapMode>
export type TPolygonType = TValueOfStringRecord<typeof EPolygonType>
export type TMapOverlayCardPositions = TValueOfStringRecord<typeof EMapOverlayCardPositions>
export type TDataType = TValueOfStringRecord<typeof EDataType>
